module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add_semester":"Neues Semester","current_semester":"Existierende Semester","generate_semester":"Erzeugen"},"en":{"add_semester":"Add Semester","current_semester":"Existing Semesters","generate_semester":"Create"}}')
  delete Component.options._Ctor
}
